import { AppIcon } from '@/components/ui/app-icon';
import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { ConnectMcpPanel } from '@/containers/integrations/connect-mcp-panel.component';
import { useFeatureAccess } from '@/hooks/use-feature-access.hook';
import { iconSpinnerThird } from '@/lib/icons';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/integrations/claude')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Head heading='Connect Claude' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          <McpRouteGuard>
            <div
              className='flex h-full flex-col overflow-y-auto text-foreground'
              style={{ padding: '24px 40px 36px' }}
            >
              <ConnectMcpPanel showBackLink />
            </div>
          </McpRouteGuard>
        </AppLayout>
      </AuthCheck>
    </>
  );
}

/**
 * MCP is visible to every org — the connect panel shows the upsell to truly-free
 * orgs and the backend 403s them, while AppSumo-only orgs are entitled and see
 * the working panel. Hold on a spinner while the entitlements matrix resolves
 * (fail closed — no flash of the MCP setup UI), and bounce back to Integrations
 * only on a hard resolution error. Mirrors the tab gate in IntegrationsContainer.
 */
function McpRouteGuard({ children }: { children: React.ReactNode }) {
  const { isReady, error } = useFeatureAccess();

  if (!isReady && !error) {
    return (
      <div className='flex h-full w-full items-center justify-center'>
        <AppIcon
          icon={iconSpinnerThird}
          className='animate-spin text-muted-foreground'
          style={{ fontSize: 20 }}
        />
      </div>
    );
  }

  if (error) {
    return <Navigate to='/integrations' replace />;
  }

  return <>{children}</>;
}
